//--------------------------------------------------------------------------//
// START HEADER CATEGORY MENU FUNCTIONS

// Get elements associated with top level categories
const categoryMenu = document.getElementById("category_menu");
const categoryTabs = document.querySelectorAll(".category-tab");
const categoryBackButtons = document.querySelectorAll(".category-back-btn");
const categoryTabPanes = document.querySelectorAll(".category-tab-pane");
// Get elements associated with sub level categories
const subcategoryTabs = document.querySelectorAll(".subcategory-tab");
const subcategoryBackButtons = document.querySelectorAll(".subcategory-back-btn");

//------------------------------------------------------------------------------------------------------//
// When a tier 1 category is clicked, hide the tier 1 category links and show the tier 2 category links.
//------------------------------------------------------------------------------------------------------//
// Add a click event listener to each tier 1 link.
categoryTabs.forEach((tab) => {
	tab.addEventListener("click", () => {
		// Hide the tier 1 category links.
		categoryMenu.classList.add("d-none");
	});
});

//-------------------------------------------------------------------------------------------------------------------------------------//
//  When the back button is clicked, hide the tier 1 category title and tier 2 category links, and return to the tier 1 category links.
//-------------------------------------------------------------------------------------------------------------------------------------//
// Add a click event listener to the tier 1 back button.
categoryBackButtons.forEach((button) => {
	button.addEventListener("click", () => {
		// Deactivate the tier 1 category tab.
		categoryTabs.forEach((tab) => {
			tab.classList.remove("active");
		});
		// Hide the tier 2 category links.
		categoryTabPanes.forEach((pane) => {
			pane.classList.remove("active", "show");
		});
		// Restore the tier 1 category links.
		categoryMenu.classList.remove("d-none");
	});
});
//-------------------------------------------------------------------//
// When a tier 2 category is clicked, hide the tier 2 category links.
//-------------------------------------------------------------------//
// Add a click event listener to each tier 2 link.
subcategoryTabs.forEach((tab) => {
	tab.addEventListener("click", () => {
		// Hide the tier 2 category links.		
		categoryTabPanes.forEach((pane) => {
			pane.classList.remove("active", "show");
		});
	});
});
//---------------------------------------------------------------------------------------------------------------------------//
// When the back button is clicked, hide the tier 2 title and tier 3 category links, and return to the tier 2 category links.
//---------------------------------------------------------------------------------------------------------------------------//
// Add a click event listener to the tier 2 back button.
subcategoryBackButtons.forEach((button) => {
	button.addEventListener("click", () => {
		// Deactivate the tier 2 category tab.
		subcategoryTabs.forEach((tab) => {
			tab.classList.remove("active");
		});
        // Hide the tier 3 category links.
        const parentDiv = button.closest(".subcategory-tab-pane");
        if (parentDiv) {
            parentDiv.classList.remove("active", "show");
        }
		// Restore the tier 2 category list
        // Traverse the previous siblings to find the first one with the 'category-tab-pane' class.
        let siblingDiv = parentDiv.previousElementSibling;
        while (siblingDiv && !siblingDiv.classList.contains("category-tab-pane")) {
            siblingDiv = siblingDiv.previousElementSibling;
        }
        // If a matching sibling is found, add 'active' and 'show' classes.
        if (siblingDiv) {
            siblingDiv.classList.add("active", "show");
        }
	});
});

//-------------------------------------------------------------------------//
// DESKTOP MODE: Toggle backdrop when category dropdown is open and closed.
//-------------------------------------------------------------------------//
const categoryDropdownButton = document.getElementById("category_button");
const customBackdrop = document.getElementById("custom_backdrop");

//--------------------------------------------------------------------------------------------------------------------------------//
// DESKTOP MODE: Return all open category menus to hidden state if the category button is visible and the dropdown menu is closed.
//--------------------------------------------------------------------------------------------------------------------------------//
// Remove 'active' and 'show' classes from all child elements of 'category_dropdown.'
const categoryDropdown = document.getElementById("category_dropdown");
document.onclick = function () {
	if (categoryDropdownButton.getAttribute("aria-expanded") === "false") {
		// Check if the 'category_button' is visible on the screen.
		const categoryButtonStyle = window.getComputedStyle(categoryDropdownButton);
		if (categoryButtonStyle.display !== "none") {
			const childElements = categoryDropdown.querySelectorAll("*");
			childElements.forEach((element) => {
				element.classList.remove("active", "show");
			});
			customBackdrop.classList.replace("d-block", "d-none");
			// Remove the 'd-none' classes from the 'category_menu' element.
			categoryMenu.classList.remove("d-none");
		}
	} else {
		customBackdrop.classList.replace("d-none", "d-block");
	}
};

//-------------------------------------------------------------------------------------------------------------------------------------------------//
// DESKTOP MODE: When the Browse Categories button is clicked, calculate height of the viewport and apply the value minus 35% to the category menu.
//-------------------------------------------------------------------------------------------------------------------------------------------------//
// Add a click event listener to the categoryDropdownButton 
categoryDropdownButton.addEventListener("click", () => {
    if (categoryDropdownButton.getAttribute("aria-expanded") !== "false") {
        // If 'aria-expanded' is not "false"
    
        // Reducing the height to 65% of the original viewport height%
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const reducedHeight = viewportHeight * 0.65;

        // Set the calculated max-height as an inline style to the element with id="category_dropdown"
        const categoryDropdownElement = document.getElementById("category_dropdown");
        if (categoryDropdownElement) {
            categoryDropdownElement.style.maxHeight = `${reducedHeight}px`;
        }
    } else {
        // If 'aria-expanded' is "false"
        // Reset the inline max-height style for the element with id="category_dropdown"
        const categoryDropdownElement = document.getElementById("category_dropdown");
        if (categoryDropdownElement) {
            categoryDropdownElement.style.maxHeight = "";
        }
    }
});

//---------------------------------------------------------------------------//
// MOBILE MODE: Open the category menu if the main menu hamburger menu is opened.
//---------------------------------------------------------------------------//
// Get the 'navbar-toggler' button element.
// const navbarTogglerButton = document.querySelector(".navbar-toggler");

// Add an event listener to the 'navbar-toggler' button to toggle the 'show' class.
// avbarTogglerButton.addEventListener("click", () => {
	// Check if the 'aria-expanded' attribute is "true" on the 'navbar-toggler' button.
	// if (navbarTogglerButton.getAttribute("aria-expanded") === "true") {
		// Add the 'show' class to the 'category_button' and 'category_dropdown'.
		// categoryDropdownButton.classList.add("show");
		// categoryDropdown.classList.add("show");
		// Set the 'aria-expanded' attribute of the 'category_button' to 'true'.
		// categoryDropdownButton.setAttribute("aria-expanded", "true");
	// } else {
		// Remove the 'show' class from the 'category_button' and 'category_dropdown'.
		// categoryDropdownButton.classList.remove("show");
		// categoryDropdown.classList.remove("show");
		// Set the 'aria-expanded' attribute of the 'category_button' to 'false'.
		// categoryDropdownButton.setAttribute("aria-expanded", "false");
	// }
// });



// Get the 'navbar-toggler' button element.
const navbarTogglerButton = document.querySelector(".navbar-toggler");

// Create a MutationObserver to watch for changes to the 'aria-expanded' attribute.
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === "aria-expanded") {
            // Check the new state of the 'aria-expanded' attribute.
            if (navbarTogglerButton.getAttribute("aria-expanded") === "true") {
                // Add the 'show' class to the 'category_button' and 'category_dropdown'.
                categoryDropdownButton.classList.add("show");
                categoryDropdown.classList.add("show");
                // Set the 'aria-expanded' attribute of the 'category_button' to 'true'.
                categoryDropdownButton.setAttribute("aria-expanded", "true");
            } else {
                // Remove the 'show' class from the 'category_button' and 'category_dropdown'.
                categoryDropdownButton.classList.remove("show");
                categoryDropdown.classList.remove("show");
                // Set the 'aria-expanded' attribute of the 'category_button' to 'false'.
                categoryDropdownButton.setAttribute("aria-expanded", "false");
            }
        }
    });
});

// Start observing the 'aria-expanded' attribute of the navbar toggler button.
observer.observe(navbarTogglerButton, { attributes: true });

// Initial state setup: If 'aria-expanded' is initially true, ensure the classes are set correctly.
if (navbarTogglerButton.getAttribute("aria-expanded") === "true") {
    categoryDropdownButton.classList.add("show");
    categoryDropdown.classList.add("show");
    categoryDropdownButton.setAttribute("aria-expanded", "true");
} else {
    categoryDropdownButton.classList.remove("show");
    categoryDropdown.classList.remove("show");
    categoryDropdownButton.setAttribute("aria-expanded", "false");
}











//----------------------------------------------------------------------------------------------------------------------------------------------//
// MOBILE MODE: Return all open category menus to hidden state if the mobile toggler button is present and the category dropdown menu is closed,
// and manage overflow on <main> and <footer>.
//----------------------------------------------------------------------------------------------------------------------------------------------//
navbarTogglerButton.addEventListener("click", () => {
    // Check if the 'aria-expanded' attribute is "true" on the 'navbar-toggler' button.
    if (navbarTogglerButton.getAttribute("aria-expanded") === "false") {
        // This condition now means the navbar is currently closed and will be opened after this click.
        const childElements = categoryDropdown.querySelectorAll("*");
        childElements.forEach((element) => {
            element.classList.remove("active", "show");
        });
        customBackdrop.classList.replace("d-block", "d-none");
        // Remove the 'd-none' classes from the 'category_menu' element.
        categoryMenu.classList.remove("d-none");

        // Remove '.overflow-hidden' class from <main> and <footer> as the navbar is going to be expanded
        document.querySelector('main').classList.remove('overflow-hidden');
        document.querySelector('footer').classList.remove('overflow-hidden');
    } else {
        // This condition now means the navbar is currently open and will be closed after this click.
        customBackdrop.classList.replace("d-none", "d-block");

        // Add '.overflow-hidden' class to <main> and <footer> as the navbar is going to be collapsed
        document.querySelector('main').classList.add('overflow-hidden');
        document.querySelector('footer').classList.add('overflow-hidden');
    }
});

// END HEADER CATEGORY MENU FUNCTIONS
//--------------------------------------------------------------------------//